import React, {Component} from 'react';
import {PropTypes} from "prop-types";
import MyThesis from "./2_Thesis/myThesis"

class MThesis extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: 'myThesis',
		}
	}

	changeTab = (id) => {
		this.setState({
			activeTab: id
		})
	}

	render() {
		// console.log(parent)
		const record = this.props.record;
		// const record = this.props.record;
		//
		return (
			<div className="tab-pane active">
				<div className="mt-px-40">
					<div className="d-flex align-items-center mb-3">
						{/*<button className={"btn-tab-nav mr-1 active-color-lightblue " + (this.state.activeTab === 'myThesis' ? 'active' : '')}*/}
						{/*        onClick={() => this.changeTab('myThesis')}>나의 논문</button>*/}
						{/*<button className={"btn-tab-nav mr-1 active-color-lightblue " + (this.state.activeTab === 'thesisReview' ? 'active' : '')}*/}
						{/*        onClick={() => this.changeTab('thesisReview')}>논문후기(논의)</button>*/}
						{/*<button className={"btn-tab-nav mr-1 active-color-lightblue " + (this.state.activeTab === 'question' ? 'active' : '')}*/}
						{/*        onClick={() => this.changeTab('question')}>질문(논의)</button>*/}
					</div>
					<div>
						{this.state.activeTab === 'myThesis' &&
							<MyThesis />
						}
						{this.state.activeTab === 'thesisReview' &&
						<div className="tab-data active">
							<div>
								<div className="position-relative">
									<div
										className="notice-point pt-3 pr-3 pb-3 pl-3 d-flex align-items-center">
										<div className="flex-auto mr-3 icon icon-size-24 icon-notice-green" />
										<div className="flex-1 font-size-14 color-black">논문의 후기를 작성해주세요.
											논문에 대한 못다한 이야기, 관련 연구자에게 하고 싶은 이야기 등 논문에 대한 후기를 작성해보세요!
											{/*<br/>*/}
											{/*(우수 작성자에게는 추첨을 통해 소정의 상품이 지급됩니다)*/}
										</div>
									</div>
									<div className="mt-3">
										<table className="table table-lightgray">
											<colgroup>
												<col width="5%"/>
												<col width="46%"/>
												<col width="22%"/>
												<col width="9%"/>
												<col width="9%"/>
												<col width="9%"/>
											</colgroup>
											<thead>
											<tr>
												<th scope="col">No.</th>
												<th scope="col" className="text-left">논문명</th>
												<th scope="col" className="text-left">학술지</th>
												<th scope="col">저자역할</th>
												<th scope="col">공개범위</th>
												<th scope="col">작성일</th>
											</tr>
											</thead>
											<tbody>
											<tr className="question">
												<td className="">1</td>
												<td className="text-left">
													<a href="#" className="color-black">Full-scale
													collapse testing of a steel stiffened plate
													structure under axial-compressive loading at a
													temperature of-80 degrees</a></td>
												<td className="text-left">전기전자재료학회 논문지<br/>2021. 30(5)
													pp.25~34
												</td>
												<td className="">단독저자</td>
												<td className="">전체공개</td>
												<td className="">
													<button type="button"
													        className="btn btn-outline-gray"><span
														className="color-lightblack">후기작성</span>
													</button>
												</td>
											</tr>
											<tr className="answer white active">
												<td></td>
												<td colSpan="5" className="text-left">
													<div className="review-detail-data">
														<div className="item-subject">켄다샤우드</div>
														<div className="item-info">
															<div className="info-cell">
																<strong>작성일자</strong>2021.03.05
															</div>
															<div className="info-cell">
																<strong>역할</strong>교신저자
															</div>
															<div className="info-cell">
																<strong>공개</strong>전체공개
															</div>
														</div>
														<div className="item-detail">논문 작성에 많은 도움을 주신
															AAA 박사님과 BBB 박사님께 진심으로 감사드립니다.<br/>본 논문은
															과핟기술정보통신부 000 기술개발(과제번호 2017-000)사업의 연구
															지원을 받아 수행되었습니다. <br/>또한, 본 연구를 위해 함께 실험을
															수핸하신 AAA, BBB, 그리고 CCC 분들께 감사의 마음을
															전합니다.<br/><br/>본 연구는 000연구소 00본부 0부의
															지원을 받아 이루어졌음에 감사드립니다.
														</div>
														<div className="item-ui text-center">
															<button type="button"
															        className="btn btn-outline-gray">
																<span className="color-lightblack">논문 후기 수정</span>
															</button>
														</div>
													</div>
												</td>
											</tr>
											<tr className="question">
												<td className="">1</td>
												<td className="text-left"><a href="#"
												                             className="color-black">Full-scale
													collapse testing of a steel stiffened plate
													structure under axial-compressive loading at a
													temperature of-80 degrees</a></td>
												<td className="text-left">전기전자재료학회 논문지<br/>2021. 30(5)
													pp.25~34
												</td>
												<td className="">단독저자</td>
												<td className="">전체공개</td>
												<td className="">2020.02.28</td>
											</tr>
											<tr className="answer white">
												<td></td>
												<td colSpan="5" className="text-left">
													<div className="review-detail-data">
														<div className="item-subject">켄다샤우드</div>
														<div className="item-info">
															<div className="info-cell">
																<strong>작성일자</strong>2021.03.05
															</div>
															<div className="info-cell">
																<strong>역할</strong>교신저자
															</div>
															<div className="info-cell">
																<strong>공개</strong>전체공개
															</div>
														</div>
														<div className="item-detail">논문 작성에 많은 도움을 주신
															AAA 박사님과 BBB 박사님께 진심으로 감사드립니다.<br/>본 논문은
															과핟기술정보통신부 000 기술개발(과제번호 2017-000)사업의 연구
															지원을 받아 수행되었습니다. <br/>또한, 본 연구를 위해 함께 실험을
															수핸하신 AAA, BBB, 그리고 CCC 분들께 감사의 마음을
															전합니다.<br/><br/>본 연구는 000연구소 00본부 0부의
															지원을 받아 이루어졌음에 감사드립니다.
														</div>
														<div className="item-ui text-center">
															<button type="button"
															        className="btn btn-outline-gray">
																<span className="color-lightblack">논문 후기 수정</span>
															</button>
														</div>
													</div>
												</td>
											</tr>
											<tr className="question">
												<td className="">1</td>
												<td className="text-left"><a href="#"
												                             className="color-black">Full-scale
													collapse testing of a steel stiffened plate
													structure under axial-compressive loading at a
													temperature of-80 degrees</a></td>
												<td className="text-left">전기전자재료학회 논문지<br/>2021. 30(5)
													pp.25~34
												</td>
												<td className="">단독저자</td>
												<td className="">전체공개</td>
												<td className="">2020.02.28</td>
											</tr>
											<tr className="answer white">
												<td></td>
												<td colSpan="5" className="text-left">
													<div className="review-detail-data">
														<div className="item-subject">켄다샤우드</div>
														<div className="item-info">
															<div className="info-cell">
																<strong>작성일자</strong>2021.03.05
															</div>
															<div className="info-cell">
																<strong>역할</strong>교신저자
															</div>
															<div className="info-cell">
																<strong>공개</strong>전체공개
															</div>
														</div>
														<div className="item-detail">논문 작성에 많은 도움을 주신
															AAA 박사님과 BBB 박사님께 진심으로 감사드립니다.<br/>본 논문은
															과핟기술정보통신부 000 기술개발(과제번호 2017-000)사업의 연구
															지원을 받아 수행되었습니다. <br/>또한, 본 연구를 위해 함께 실험을
															수핸하신 AAA, BBB, 그리고 CCC 분들께 감사의 마음을
															전합니다.<br/><br/>본 연구는 000연구소 00본부 0부의
															지원을 받아 이루어졌음에 감사드립니다.
														</div>
														<div className="item-ui text-center">
															<button type="button"
															        className="btn btn-outline-gray">
																<span className="color-lightblack">논문 후기 수정</span>
															</button>
														</div>
													</div>
												</td>
											</tr>
											<tr className="question">
												<td className="">1</td>
												<td className="text-left"><a href="#"
												                             className="color-black">Full-scale
													collapse testing of a steel stiffened plate
													structure under axial-compressive loading at a
													temperature of-80 degrees</a></td>
												<td className="text-left">전기전자재료학회 논문지<br/>2021. 30(5)
													pp.25~34
												</td>
												<td className="">단독저자</td>
												<td className="">전체공개</td>
												<td className="">2020.02.28</td>
											</tr>
											<tr className="answer white">
												<td></td>
												<td colSpan="5" className="text-left">
													<div className="review-detail-data">
														<div className="item-subject">켄다샤우드</div>
														<div className="item-info">
															<div className="info-cell">
																<strong>작성일자</strong>2021.03.05
															</div>
															<div className="info-cell">
																<strong>역할</strong>교신저자
															</div>
															<div className="info-cell">
																<strong>공개</strong>전체공개
															</div>
														</div>
														<div className="item-detail">논문 작성에 많은 도움을 주신
															AAA 박사님과 BBB 박사님께 진심으로 감사드립니다.<br/>본 논문은
															과핟기술정보통신부 000 기술개발(과제번호 2017-000)사업의 연구
															지원을 받아 수행되었습니다. <br/>또한, 본 연구를 위해 함께 실험을
															수핸하신 AAA, BBB, 그리고 CCC 분들께 감사의 마음을
															전합니다.<br/><br/>본 연구는 000연구소 00본부 0부의
															지원을 받아 이루어졌음에 감사드립니다.
														</div>
														<div className="item-ui text-center">
															<button type="button"
															        className="btn btn-outline-gray">
																<span className="color-lightblack">논문 후기 수정</span>
															</button>
														</div>
													</div>
												</td>
											</tr>
											<tr className="question">
												<td className="">1</td>
												<td className="text-left"><a href="#"
												                             className="color-black">Full-scale
													collapse testing of a steel stiffened plate
													structure under axial-compressive loading at a
													temperature of-80 degrees</a></td>
												<td className="text-left">전기전자재료학회 논문지<br/>2021. 30(5)
													pp.25~34
												</td>
												<td className="">단독저자</td>
												<td className="">전체공개</td>
												<td className="">2020.02.28</td>
											</tr>
											<tr className="answer white">
												<td></td>
												<td colSpan="5" className="text-left">
													<div className="review-detail-data">
														<div className="item-subject">켄다샤우드</div>
														<div className="item-info">
															<div className="info-cell">
																<strong>작성일자</strong>2021.03.05
															</div>
															<div className="info-cell">
																<strong>역할</strong>교신저자
															</div>
															<div className="info-cell">
																<strong>공개</strong>전체공개
															</div>
														</div>
														<div className="item-detail">논문 작성에 많은 도움을 주신
															AAA 박사님과 BBB 박사님께 진심으로 감사드립니다.<br/>본 논문은
															과핟기술정보통신부 000 기술개발(과제번호 2017-000)사업의 연구
															지원을 받아 수행되었습니다. <br/>또한, 본 연구를 위해 함께 실험을
															수핸하신 AAA, BBB, 그리고 CCC 분들께 감사의 마음을
															전합니다.<br/><br/>본 연구는 000연구소 00본부 0부의
															지원을 받아 이루어졌음에 감사드립니다.
														</div>
														<div className="item-ui text-center">
															<button type="button"
															        className="btn btn-outline-gray">
																<span className="color-lightblack">논문 후기 수정</span>
															</button>
														</div>
													</div>
												</td>
											</tr>
											</tbody>
										</table>
									</div>
									<div className="mt-4">
										<div>
											<div className="paging-wrap">
												<ul className="pagination">
													<li className="page-item page-item-first"><a
														className="page-link" href="#">처음으로</a></li>
													<li className="page-item page-item-prev"><a
														className="page-link" href="#">이전</a></li>
													<li className="page-item active"
													    aria-current="page"><a className="page-link"
													                           href="#">1</a></li>
													<li className="page-item"><a className="page-link"
													                             href="#">2</a></li>
													<li className="page-item"><a className="page-link"
													                             href="#">3</a></li>
													<li className="page-item"><a className="page-link"
													                             href="#">4</a></li>
													<li className="page-item"><a className="page-link"
													                             href="#">5</a></li>
													<li className="page-item page-item-next"><a
														className="page-link" href="#">다음</a></li>
													<li className="page-item page-item-last"><a
														className="page-link" href="#">마지막으로</a></li>
												</ul>
											</div>
										</div>
									</div>
									<div className="position-absolute right-0 bottom-100 mb-3">
										<div className="d-flex align-items-center">
											<div className="font-size-14 color-lightblue"><strong>미확인 논문
												20</strong></div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
						{this.state.activeTab === 'question' &&
						<div className="tab-data active">
							<div>
								<div className="position-relative">
									<div className="">
										<table className="table table-lightgray">
											<colgroup>
												<col width="9%"/>
												<col width="69%"/>
												<col width="11%"/>
												<col width="11%"/>
											</colgroup>
											<thead>
											<tr>
												<th scope="col">답변완료</th>
												<th scope="col" className="text-left">내용</th>
												<th scope="col">작성자</th>
												<th scope="col">작성일</th>
											</tr>
											</thead>
											<tbody>
											<tr className="question">
												<td className="">
													<div
														className="badge outline-gray rounded-4 badge-sm">
														<span className="color-lightblack">미완료</span>
													</div>
												</td>
												<td className="text-left"><a href="#"
												                             className="color-black">이
													논문의 결론이 이게 맞나요?</a></td>
												<td className="">abcd••••</td>
												<td className="">2021.10.20</td>
											</tr>
											<tr className="answer active">
												<td></td>
												<td colSpan="3" className="text-left">
													<div
														className="answer-data font-size-14 color-black">네
														맞습니다.<br/>다시 한번 읽어 보세요.
													</div>
												</td>
											</tr>
											<tr className="question">
												<td className="">
													<div
														className="badge outline-gray rounded-4 badge-sm">
														<span className="color-lightblack">미완료</span>
													</div>
												</td>
												<td className="text-left"><a href="#"
												                             className="color-black">이
													논문의 결론이 이게 맞나요?</a></td>
												<td className="">abcd••••</td>
												<td className="">2021.10.20</td>
											</tr>
											<tr className="answer active">
												<td></td>
												<td colSpan="3" className="text-left">
													<div
														className="answer-data font-size-14 color-black">네
														맞습니다.<br/>다시 한번 읽어 보세요.
													</div>
												</td>
											</tr>
											<tr className="question">
												<td className="">
													<div
														className="badge outline-gray rounded-4 badge-sm">
														<span className="color-skyblue">완료</span></div>
												</td>
												<td className="text-left"><a href="#"
												                             className="color-black">이
													논문의 결론이 이게 맞나요?</a></td>
												<td className="">abcd••••</td>
												<td className="">2021.10.20</td>
											</tr>
											<tr className="answer">
												<td></td>
												<td colSpan="3" className="text-left">
													<div
														className="answer-data font-size-14 color-black">네
														맞습니다.<br/>다시 한번 읽어 보세요.
													</div>
												</td>
											</tr>
											<tr className="question">
												<td className="">
													<div
														className="badge outline-gray rounded-4 badge-sm">
														<span className="color-skyblue">완료</span></div>
												</td>
												<td className="text-left"><a href="#"
												                             className="color-black">이
													논문의 결론이 이게 맞나요?</a></td>
												<td className="">abcd••••</td>
												<td className="">2021.10.20</td>
											</tr>
											<tr className="answer">
												<td></td>
												<td colSpan="3" className="text-left">
													<div
														className="answer-data font-size-14 color-black">네
														맞습니다.<br/>다시 한번 읽어 보세요.
													</div>
												</td>
											</tr>
											<tr className="question">
												<td className="">
													<div
														className="badge outline-gray rounded-4 badge-sm">
														<span className="color-skyblue">완료</span></div>
												</td>
												<td className="text-left"><a href="#"
												                             className="color-black">이
													논문의 결론이 이게 맞나요?</a></td>
												<td className="">abcd••••</td>
												<td className="">2021.10.20</td>
											</tr>
											<tr className="answer">
												<td></td>
												<td colSpan="3" className="text-left">
													<div
														className="answer-data font-size-14 color-black">네
														맞습니다.<br/>다시 한번 읽어 보세요.
													</div>
												</td>
											</tr>
											</tbody>
										</table>
									</div>
									<div className="mt-4">
										<div>
											<div className="paging-wrap">
												<ul className="pagination">
													<li className="page-item page-item-first"><a
														className="page-link" href="#">처음으로</a></li>
													<li className="page-item page-item-prev"><a
														className="page-link" href="#">이전</a></li>
													<li className="page-item active"
													    aria-current="page"><a className="page-link"
													                           href="#">1</a></li>
													<li className="page-item"><a className="page-link"
													                             href="#">2</a></li>
													<li className="page-item"><a className="page-link"
													                             href="#">3</a></li>
													<li className="page-item"><a className="page-link"
													                             href="#">4</a></li>
													<li className="page-item"><a className="page-link"
													                             href="#">5</a></li>
													<li className="page-item page-item-next"><a
														className="page-link" href="#">다음</a></li>
													<li className="page-item page-item-last"><a
														className="page-link" href="#">마지막으로</a></li>
												</ul>
											</div>
										</div>
									</div>
									<div className="position-absolute right-0 bottom-100 mb-3">
										<div className="d-flex align-items-center">
											<div className="font-size-14 color-lightblue"><strong>답변대기
												20</strong></div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
					</div>
				</div>
			</div>
		);
	}
};

export default MThesis;
